import { TabPanelIndex, TabContentContainerIndex } from "./styles";

function CustomTabPanel({ children, value, index }) {
  return (
    <TabPanelIndex $visible={value === index}>
      <TabContentContainerIndex>{children}</TabContentContainerIndex>
    </TabPanelIndex>
  );
}

export default CustomTabPanel;
